export const HOME = '/';
export const SIGN_UP = '/sign-up';
export const STORIES_EDIT = '/stories/:id/edit';
